<div class="container">
    <h1 class="text-uppercase">All Channels</h1>
    <h2 class="text-uppercase">{{productId}}</h2>
    <app-from-to-channel [channels]="channels" (fromTo)="rechannel($event)"></app-from-to-channel>
</div>